export default __webpack_public_path__ + "static/android-icon-192x192-e3c682c3d03d8cd16b537dfed33ca94e.png";